import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import absences from './absences';
import agenda from './agenda';
import alarms from './alarms';
import app from './app';
import auth from './auth';
import buses from './buses';
import carriers from './carriers';
import contacts from './contacts';
import devOverlay from './devOverlay';
import diversion from './diversion';
import drivers from './drivers';
import modal from './modal';
import noticeTemplates from './noticeTemplates';
import notices from './notices';
import profile from './profile';
import pupils from './pupils';
import staff from './staff';
import tabFocus from './tabFocus';
import routes from './routes';
import eca from './eca';
import settings from './settings';
import students from './students';
import sos from './sos';
import users from './users';
import callSession from './callSession';
import statistics from './Statistics';
import report from './report';
import ws from './wsNotifications';
import importExport from './importExport';

const reducers = combineReducers({
  routing: routerReducer,
  absences,
  agenda,
  alarms,
  app,
  auth,
  buses,
  carriers,
  contacts,
  devOverlay,
  diversion,
  drivers,
  eca,
  importExport,
  modal,
  noticeTemplates,
  notices,
  profile,
  pupils,
  staff,
  tabFocus,
  routes,
  settings,
  students,
  sos,
  users,
  callSession,
  statistics,
  report,
  ws,
});

export default reducers;
